__turbopack_context__.v({
  "selectedOption": "SelectionScreen-module-scss-module__h7kq5a__selectedOption",
  "selectionScreen": "SelectionScreen-module-scss-module__h7kq5a__selectionScreen",
});
